import React from 'react';
import { states } from '@/constants/lifecycle';
import Filter from '@/components/Filter';
import TaskViewsDropdown from './TaskViewsDropdown';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const TasksFilters = ({ category, className, fluid }) => {
  const {
    allowQueries, filterTerm, readStatus, view,
  } = Selectors.useTasksFilters({ category });
  const fetchData = Events.useFetchRequestTasks(category);
  const updateFilterTerm = Events.useUpdateTasksFilter(category);

  const filterComponent = (
    <Filter
      className={fluid ? 'aridhia-list-filter' : undefined}
      error={readStatus === states.ERROR}
      filterTerm={filterTerm}
      fluid={fluid}
      onFilter={() => fetchData({ page: 1 })}
      updateFilter={({ value }) => updateFilterTerm({ value })}
    />
  );
  const dropDownComponent = (
    <TaskViewsDropdown
      category="all"
      className={fluid ? 'mt-5' : 'mr-10'}
      clearable
      disabled={readStatus === states.PENDING}
      fluid={fluid}
      view={view}
    />
  );

  const components = { first: allowQueries ? dropDownComponent : null, second: filterComponent };
  if (allowQueries && fluid) {
    components.first = filterComponent;
    components.second = dropDownComponent;
  }

  return (
    <div className={`aridhia-tasks-filters ${className}`}>
      {components.first && (<>{components.first}</>)}
      {components.second && (<>{components.second}</>)}
    </div>
  );
};

export default TasksFilters;
